/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_EmailChange_AdminEmailOverrideDto } from '../models/Wealthlane_Dtos_EmailChange_AdminEmailOverrideDto';
import type { Wealthlane_Dtos_EmailChange_AdminEmailOverrideResponseDto } from '../models/Wealthlane_Dtos_EmailChange_AdminEmailOverrideResponseDto';
import type { Wealthlane_Dtos_EmailChange_FinalizeEmailChangeDto } from '../models/Wealthlane_Dtos_EmailChange_FinalizeEmailChangeDto';
import type { Wealthlane_Dtos_EmailChange_FinalizeEmailChangeResponseDto } from '../models/Wealthlane_Dtos_EmailChange_FinalizeEmailChangeResponseDto';
import type { Wealthlane_Dtos_EmailChange_InitiateEmailChangeDto } from '../models/Wealthlane_Dtos_EmailChange_InitiateEmailChangeDto';
import type { Wealthlane_Dtos_EmailChange_InitiateEmailChangeResponseDto } from '../models/Wealthlane_Dtos_EmailChange_InitiateEmailChangeResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmailChangeService {

    /**
     * @param requestBody 
     * @returns Wealthlane_Dtos_EmailChange_InitiateEmailChangeResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppEmailChangeInitiateEmailChange(
        requestBody?: Wealthlane_Dtos_EmailChange_InitiateEmailChangeDto,
    ): CancelablePromise<Wealthlane_Dtos_EmailChange_InitiateEmailChangeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/email-change/initiate-email-change',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Dtos_EmailChange_FinalizeEmailChangeResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppEmailChangeFinalizeEmailChange(
        requestBody?: Wealthlane_Dtos_EmailChange_FinalizeEmailChangeDto,
    ): CancelablePromise<Wealthlane_Dtos_EmailChange_FinalizeEmailChangeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/email-change/finalize-email-change',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Dtos_EmailChange_AdminEmailOverrideResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppEmailChangeAdminTemporaryEmailUpdate(
        requestBody?: Wealthlane_Dtos_EmailChange_AdminEmailOverrideDto,
    ): CancelablePromise<Wealthlane_Dtos_EmailChange_AdminEmailOverrideResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/email-change/admin-temporary-email-update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
